import { byName } from "./filters"

export function reducer(state, action) {
  switch (action.type) {
    case "set_unsaved_changes": {
      return { ...state, unsavedChanges: action.payload }
    }
    case "set_metadata": {
      return {
        ...state,
        metadata: { ...state.metadata, ...action.payload.metadata }
      }
    }
    case "set_current_page": {
      return { ...state, currentPageId: action.payload.pageId }
    }
    case "update_page": {
      let pageIndex = state.pages.findIndex(
        page => page.id === action.payload.pageId
      )

      if (pageIndex === -1) {
        pageIndex = state.pages.length
      }

      const page = state.pages[pageIndex] || {}

      const pages = Object.assign([], state.pages, {
        [pageIndex]: { ...page, ...action.payload }
      })

      return { ...state, pages }
    }
    case "remove_page": {
      const pages = state.pages.filter(
        page => page.id !== action.payload.pageId
      )

      return { ...state, pages }
    }
    case "update_style": {
      const pageIndex = state.pages.findIndex(
        page => page.id === state.currentPageId
      )

      const page = state.pages[pageIndex]

      let styleIndex = page.styles.findIndex(byName(action.payload.name))

      if (styleIndex == -1) styleIndex = page.styles.length

      const styles = Object.assign([], page.styles, {
        [styleIndex]: {
          ...page.styles[styleIndex],
          ...{ ...action.payload }
        }
      })

      const pages = Object.assign([], state.pages, {
        [pageIndex]: { ...state.pages[pageIndex], styles }
      })

      return { ...state, pages }
    }
    case "update_element": {
      const pageIndex = state.pages.findIndex(
        page => page.id === state.currentPageId
      )

      const page = state.pages[pageIndex]

      let elementIndex = page.elements.findIndex(byName(action.payload.name))

      if (elementIndex == -1) elementIndex = page.elements.length

      const elements = Object.assign([], page.elements, {
        [elementIndex]: {
          ...page.elements[elementIndex],
          ...{ ...action.payload }
        }
      })

      const pages = Object.assign([], state.pages, {
        [pageIndex]: { ...state.pages[pageIndex], elements }
      })

      return { ...state, pages }
    }
    case "update_setting": {
      let settingIndex = state.settings.findIndex(byName(action.payload.name))

      if (settingIndex == -1) settingIndex = state.settings.length

      const settings = Object.assign([], state.settings, {
        [settingIndex]: { ...state.settings[settingIndex], ...action.payload }
      })

      return { ...state, settings }
    }
  }
}
